var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recommendable-person"},[_c('StackRouterHeaderBar'),_c('main',{staticClass:"main"},[_c('FeedbackTop',{staticClass:"m-b-40",attrs:{"title":'다른 이성에게<br />소개해줘도 괜찮은 분인가요?'}}),_c('FeedbackOptionItems',{on:{"select":_vm.onSelectItem},model:{value:(_vm.items),callback:function ($$v) {_vm.items=$$v},expression:"items"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }